"use strict";
/* generated by gulpfile.js */
module.exports = exports = function () {
	return [
		"<input>",
		"alwaysShowCalendars",
		"applyClass",
		"autoApply",
		"autoUpdateInput",
		"buttonClasses",
		"cancelClass",
		"dateLimit",
		"drops",
		"endDate",
		"isCustomDate",
		"isInvalidDate",
		"linkedCalendars",
		"locale",
		"maxDate",
		"minDate",
		"opens",
		"parentEl",
		"ranges",
		"showCustomRangeLabel",
		"showDropdowns",
		"showISOWeekNumbers",
		"showWeekNumbers",
		"singleDatePicker",
		"startDate",
		"template",
		"timePicker",
		"timePicker24Hour",
		"timePickerIncrement",
		"timePickerSeconds"
];
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap-daterangepicker/lib/get-options.js
 ** module id = 1440
 ** module chunks = 0
 **/